import React from 'react';

const TextColor = ({ color, onClick, pickerColor }) => {
  return (
    <svg
      id='Group_78890'
      data-name='Group 78890'
      xmlns='http://www.w3.org/2000/svg'
      width='39.99'
      height='19'
      viewBox='0 0 39.99 19'
      onClick={onClick}
      cursor='pointer'
    >
      <text
        id='Password'
        transform='translate(0 15)'
        fill={color}
        font-size='16'
        font-family='Roboto-Bold, Roboto'
        font-weight='700'
        letter-spacing='0em'
        text-decoration='underline'
      >
        <tspan x='0' y='0'>
          A
        </tspan>
      </text>
      <rect
        id='Rectangle_146284'
        data-name='Rectangle 146284'
        width='21.182'
        height='14.317'
        rx='2'
        transform='translate(18.807 3.596)'
        fill={pickerColor}
      />
    </svg>
  );
};

export default TextColor;
